import { render, staticRenderFns } from "./file-rocket.vue?vue&type=template&id=2213b5c1&scoped=true&"
import script from "./file-rocket.vue?vue&type=script&lang=js&"
export * from "./file-rocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213b5c1",
  null
  
)

export default component.exports